import { translations } from "./locales"

export default class Translator {
  get locale() { return $("head meta[name=curcipapers-locale]").attr("content") }

  t(identifier) {
    return translations[this.locale][identifier]
  }
}
